/* eslint-disable react-hooks/exhaustive-deps */
import Grid from '@material-ui/core/Grid';
import { Layout, Text } from 'components/styleguide';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useRootTranslation } from 'utils/hooks';
import { MAX_FILE_BYTES } from 'redux-core/import-commercial-tracks/constants';

const ACCEPTED_FORMATS = '.xlsx';
const rootT = 'drawers.importCommercialTracksDrawer.dropzone';

const FileDropZone = ({ onFile, onRejected }) => {
  const t = useRootTranslation(rootT);

  const useOnDrop = () =>
    useCallback(
      (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (!file) return;
        onFile(file);
      },
      [onFile],
    );

  const useOnDropRejected = () =>
    useCallback(
      (rejectedFiles) => {
        const file = (rejectedFiles || [])[0];
        if (!file) return;
        if (file.size > MAX_FILE_BYTES) {
          onRejected([{ code: 'FILE_TOO_LARGE' }]);
          return;
        }
        onRejected([{ code: 'NOT_EXCEL_FILE' }]);
      },
      [onRejected],
    );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: useOnDrop(),
    onDropRejected: useOnDropRejected(),
    accept: ACCEPTED_FORMATS,
    maxFiles: 1,
    maxSize: MAX_FILE_BYTES,
  });

  return (
    <Layout width="auto" height="auto" p={1} container>
      <Grid item container>
        <div
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...getRootProps()}
          data-testid="import-commercial-tracks-dropzone"
          style={{
            width: '100%',
            height: 'calc(100vh - 520px)',
            minHeight: 220,
            border: '1px dashed #cccccc',
            borderRadius: '4px',
            padding: '20px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <input {...getInputProps()} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '42px',
                height: '42px',
                borderRadius: '100%',
                backgroundColor: '#d9d9d9',
              }}
            >
              <UploadFileIcon style={{ color: '#282078' }} />
            </div>
            <div>
              <Text variant="formLabel">{t('title')}</Text>
            </div>
            <div>
              <Text variant="formLabel">{t('maxSize')}</Text>
            </div>
          </div>
        </div>
      </Grid>
    </Layout>
  );
};

export default FileDropZone;
